import { ArrowCta, FormCard, HStack, Link, Text } from 'components/ui';
import { Box } from '@chakra-ui/react';
import HeaderNav from '../HeaderNav/HeaderNav';
import LongFormAddress from './components/LongFormAddress';
import { useLocationView } from './hooks/useLocationView';
import { LoadingScreen } from '../ui/LoadingScreen';
import { LocationSelect } from './components/LocationSelect';
import { LocationHeader } from './components/LocationHeader';
import { StickyCtaLayout } from '../ui/StickyCtaLayout';
import { ChevronLeft } from 'lucide-react';

export const Location = () => {
  const {
    address,
    currentLocationStep,
    error,
    loading,
    locationInputValue,
    onLocationSelect,
    onSave,
    selectedLocation,
    setAddress,
    setCurrentLocationStep,
    setLocationInputValue,
  } = useLocationView();

  if (loading) return <LoadingScreen />;

  const { street, street2, city, state, zip } = address || {};
  const isDisabled = !street || !city || !state || !zip;

  return (
    <StickyCtaLayout
      actionArea={
        currentLocationStep !== 'geosuggest' && (
          <ArrowCta
            disabled={isDisabled}
            alignSelf={'center'}
            onClick={() => {
              onSave({
                street: street2 ? `${street}, ${street2}` : street,
                city: city,
                state: state,
                zip: zip,
              });
            }}
          >
            Looks Good!
          </ArrowCta>
        )
      }
      header={<HeaderNav />}
      maxWidth="formWidth"
    >
      <LocationHeader error={error} />

      <Box w={'100%'} maxW={'formWidth'} alignSelf={'center'} px={0} mt={8}>
        {currentLocationStep === 'form' && (
          <HStack alignItems={'center'} mb={2}>
            <Link
              isExternal={false}
              onClick={() => setCurrentLocationStep('geosuggest')}
              fontFamily={'body'}
              fontSize={'13.5px'}
              fontWeight={600}
              color={'blueGray.600'}
              textDecoration={'none'}
            >
              <ChevronLeft size={13.5} />
              Search for a different address
            </Link>
          </HStack>
        )}

        <FormCard>
          {currentLocationStep === 'geosuggest' ? (
            <LocationSelect
              locationInputValue={locationInputValue}
              onLocationSelect={onLocationSelect}
              selectedLocation={selectedLocation}
              setLocationInputValue={setLocationInputValue}
            />
          ) : (
            <LongFormAddress address={address} onChange={setAddress} />
          )}
        </FormCard>

        {currentLocationStep === 'geosuggest' && (
          <Box textAlign={'center'} my={6}>
            <Text color={'blueGray.600'}>
              Can't find your address?{' '}
              <Link
                color={'aqua.500'}
                fontWeight={600}
                isExternal={false}
                textDecoration={'none'}
                onClick={() => setCurrentLocationStep('form')}
              >
                Enter it manually
              </Link>
            </Text>
          </Box>
        )}
      </Box>
    </StickyCtaLayout>
  );
};
